<template>
  <div class="homepage">
    <FilterDatas 
      v-show="false"
      :collection="collection" 
      :mode="'prod'" 
      :model="['id', 'name', 'tags']"
      :setQuery="queryFromSidebar"
      @filteredData="filteredLogs"></FilterDatas>
    <el-dialog
      class="custom-modal-size"
      title="Filter"
      width="1100px"
      :visible.sync="getFilterModalVisible">
      <FilterDatas 
        :collection="collection" 
        :mode="'prod'" 
        :model="['id', 'name', 'tags']"
        :setQuery="queryFromSidebar"
        @filteredData="filteredLogs"></FilterDatas>
      <el-button @click="closeFilterModal">Fermer</el-button>
    </el-dialog>
    <!-- <ListOf :oflist="filteredCollection"></ListOf> -->
    <el-card class="custom-margin-bottom ">
      <TopBarMiniCard
        :title="$t('production_area')"
        :cardLoaded="collection.length"
        :isLoaded="'isAllProductionZonesLoaded'"
        @clickLoadMore="loadMoreData"
        @refresh="refreshData"
        @createNew="createNew"
      ></TopBarMiniCard>
    </el-card>
    <CardMiniProductionZone v-for="(pz, idx) in filteredCollection" :key="idx" :productionZone="pz"></CardMiniProductionZone>
    <!-- start Modal for Create OF form -->
    <el-dialog
      width="1200px"
      :visible.sync="dialogFormVisible"
      :modalAppendToBody="false">
        <CreateProductionZoneModal :key="dialogFormVisible" @closeForm="closeCreationForm"></CreateProductionZoneModal>
    </el-dialog>
    <!-- end Modal for Create OF form -->
  </div>
</template>

<script>
// import { opFabTable } from '../data/dynamoDBSimulation'

import CardMiniProductionZone from '@/components/CardMiniProductionZone.vue'
import TopBarMiniCard from '../components/TopBarMiniCard.vue'
import FilterDatas from '@/components/vuejs-components-collection/components-collection/FilterDatas.vue'
import CreateProductionZoneModal from '../components/production-zone/CreateProductionZoneModal'

export default {
  name: 'productionArea',
  components: {
    FilterDatas,
    CardMiniProductionZone,
    TopBarMiniCard,
    CreateProductionZoneModal
  },
  data() {
    return {
      filteredCollection: [],
      dialogFormVisible: false
    }
  },
  mounted() {
    if(this.$store.getters.productionZones.length === 0) {
      this.$store.dispatch('getProductionZones');
    }
    if(this.$store.getters.manufacturingOrders.length === 0) {
      this.$store.dispatch('getManufacturingOrders');
    }
    if(this.$store.getters.beacons.length === 0) {
      this.$store.dispatch('getBeacons');
    }
  },
  created() {
    this.filteredCollection = this.collection;
  },
  watch: {
    collection: function() {
      this.filteredCollection = this.collection;
    }
  },
  computed : {
    collection() {
      return this.$store.getters.productionZones
    },
    allLoaded() {
      return this.$store.getters.isAllProductionZonesLoaded;
    },
    getFilterModalVisible: {
      get: function() {
        return this.$store.getters.getFilterModalVisible;
      },
      set: function() {
        return this.$store.dispatch('switchFilterModalVisible', false);
      }
    },
    queryFromSidebar() {
      return this.$store.getters.searchFavSelected;
    }
  },
  methods: {
    filteredLogs: function(event) {
      this.filteredCollection = event;
    },
    loadMoreData: function() {
      this.$store.dispatch('loadMoreProductionZones');
    },
    refreshData: function() {
      this.$store.dispatch('refreshProductionZones');
    },
    closeFilterModal: function() {
      this.$store.dispatch('switchFilterModalVisible');
    },
    createNew: function() {
      this.dialogFormVisible = true;
    },
     closeCreationForm: function() {
      this.dialogFormVisible = false;
    }
  }
}
</script>

<style lang="css" scoped>
  .homepage {
    min-width: 950px;
  }

  .custom-modal-size {
    margin: auto;
  }

  .custom-margin-bottom {
    margin-bottom: 20px;
  }

  .el-dialog {
    width: 1100px !important;
  }

</style>
